import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IRankingStore} from "data/stores/ranking/ranking.store";
import type {IUserRank} from "data/providers/api/ranking.api.provider";
import {ModalType} from "data/enums";
import type {IShareStore} from "data/stores/share/share.store";
import type {IModalsStore} from "data/stores/modals/modals.store";

export interface IUserScoringController extends ViewController {
	readonly i18n: ILocalizationStore;

	get userRank(): IUserRank | null;
	get maxUserRank(): number | null;

	onOpenShareModal: () => void;
}

@injectable()
export class UserScoringController implements IUserScoringController {
	get userRank() {
		return this._rankingStore.userRank;
	}

	get maxUserRank() {
		return this._rankingStore.maxUserRank;
	}
	constructor(
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore,
		@inject(Bindings.RankingStore) private _rankingStore: IRankingStore,
		@inject(Bindings.ShareStore) private _shareStore: IShareStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	onOpenShareModal = () => {
		void this._shareStore.sharePredictionImage();
		this._modalsStore.showModal(ModalType.SHARE_PICKS, {
			message: "",
		});
	};
}
